import { logger } from '../core/logger';
import { normalizeDomain } from './domain';

/** Whether a link leads to an `http(s)` page of the given site; false for an invalid URL. */
function isPageOfSite(href: string, site: string): boolean {
    try {
        const url = new URL(href);
        return /^https?:$/.test(url.protocol) && normalizeDomain(url.hostname) === site;
    } catch {
        return false;
    }
}

/**
 * This page's translations from its `hreflang` alternates: language tag → URL (IX-5893).
 * Only `http(s)` URLs on the page's own site; `x-default` names no language.
 * Never throws: it runs on every send, and a host page must not cost the visitor a message.
 */
export function readPageAlternates(): Record<string, string> | undefined {
    try {
        const site = normalizeDomain(window.location.hostname);
        const alternates = new Map<string, string>();
        for (const link of document.querySelectorAll<HTMLLinkElement>(
            'link[rel~="alternate"][hreflang][href]'
        )) {
            const tag = link.hreflang.toLowerCase();
            if (
                tag &&
                tag !== 'x-default' &&
                !alternates.has(tag) &&
                isPageOfSite(link.href, site)
            ) {
                alternates.set(tag, link.href);
            }
        }
        return alternates.size > 0 ? Object.fromEntries(alternates) : undefined;
    } catch (error) {
        logger.debug('Could not read the page alternates', error);
        return undefined;
    }
}
